// Account Drawer - handles account login/register
if (!customElements.get("custom-drawer")) {
  class CustomDrawer extends HTMLElement {
    constructor() {
      super();
      this.body = document.querySelector("body");
    }

    connectedCallback() {
      this.overlay = document.querySelector(".drawer__overlay");
      this.closeBtn = this.querySelectorAll(".icn-close, .account-drawer__close-btn");

      // Handle account links - only open drawer for non-logged-in users
      const accountLinks = document.querySelectorAll(".cart-links__link-account a");
      accountLinks.forEach((link) => {
        link.addEventListener("click", (event) => {
          // Check if the link has drawer attributes (non-logged-in users)
          if (link.hasAttribute("data-drawer-open")) {
            event.preventDefault();
            console.log("Account link clicked - opening account drawer");
            this.openDrawer("account-drawer");
          }
          // If no drawer attributes, let the link navigate normally (logged-in users)
        });
      });

      // Close drawer when clicking outside of it
      if (this.overlay) {
        this.overlay.addEventListener("click", () => this.closeModal());
      }

      this.closeBtn.forEach((el) => {
        el.addEventListener("click", () => this.closeModal());
      });
    }

    openDrawer(id) {
      // Close any other open drawers first
      this.closeAllDrawers();

      this.removeActiveItem();

      const item = this.querySelector(`#${id}`);
      if (item) {
        item.classList.add("drawer__item--active");
        this.classList.add("drawer--active");
        this.body.classList.add("drawer__open");
      }
    }

    closeAllDrawers() {
      // Close all other drawers
      const allDrawers = document.querySelectorAll("custom-drawer, info-blocks-drawer");
      allDrawers.forEach((drawer) => {
        if (drawer !== this) {
          drawer.classList.remove("drawer--active");
          drawer.querySelectorAll(".drawer__item--active").forEach((item) => {
            item.classList.remove("drawer__item--active");
          });
        }
      });
    }

    closeModal() {
      this.removeActiveItem();
      this.classList.remove("drawer--active");
      this.body.classList.remove("drawer__open");
    }

    // Remove the active class from the currently active item
    removeActiveItem() {
      const activeItem = this.querySelector(".drawer__item--active");
      if (activeItem) {
        activeItem.classList.remove("drawer__item--active");
      }
    }
  }

  customElements.define("custom-drawer", CustomDrawer);
}

// Info Blocks Drawer - handles info-blocks content
if (!customElements.get("info-blocks-drawer")) {
  class InfoBlocksDrawer extends HTMLElement {
    constructor() {
      super();
      this.body = document.querySelector("body");
    }

    connectedCallback() {
      this.overlay = document.querySelector(".drawer__overlay");
      this.closeBtn = this.querySelectorAll(".icn-close");
      this.trigger = document.querySelectorAll("[data-info-drawer-open]");

      // Open drawer when clicking on elements with data-info-drawer-open attribute
      this.trigger.forEach((el) => {
        el.addEventListener("click", (event) => {
          event.preventDefault();
          const targetId = el.getAttribute("data-info-drawer-target");
          console.log("Info drawer targetId", targetId);
          this.openDrawer(targetId);
        });
      });

      // Close drawer when clicking outside of it
      if (this.overlay) {
        this.overlay.addEventListener("click", () => this.closeModal());
      }

      this.closeBtn.forEach((el) => {
        el.addEventListener("click", () => this.closeModal());
      });
    }

    openDrawer(id) {
      // Close any other open drawers first
      this.closeAllDrawers();

      this.removeActiveItem();

      const item = this.querySelector(`#${id}`);
      if (item) {
        item.classList.add("drawer__item--active");
        this.classList.add("drawer--active");
        this.body.classList.add("drawer__open");
      }
    }

    closeAllDrawers() {
      // Close all other drawers
      const allDrawers = document.querySelectorAll("custom-drawer, info-blocks-drawer");
      allDrawers.forEach((drawer) => {
        if (drawer !== this) {
          drawer.classList.remove("drawer--active");
          drawer.querySelectorAll(".drawer__item--active").forEach((item) => {
            item.classList.remove("drawer__item--active");
          });
        }
      });
    }

    closeModal() {
      this.removeActiveItem();
      this.classList.remove("drawer--active");
      this.body.classList.remove("drawer__open");
    }

    // Remove the active class from the currently active item
    removeActiveItem() {
      const activeItem = this.querySelector(".drawer__item--active");
      if (activeItem) {
        activeItem.classList.remove("drawer__item--active");
      }
    }
  }

  customElements.define("info-blocks-drawer", InfoBlocksDrawer);
}
